(() => {
  const root = document.querySelector('[data-fcatalog]');
  if (!root) return;
  const base = root.dataset.root || '/';
  const approved = root.dataset.approved === 'true';
  let cart = null;
  let busy = false;
  const cards = [...root.querySelectorAll('[data-catalog-card]')];
  const knownIds = new Set([...root.querySelectorAll('[data-catalog-variant] option')].map(o => Number(o.value)));
  const status = root.querySelector('[data-cart-status]');
  const money = value => new Intl.NumberFormat('ja-JP', { style: 'currency', currency: cart?.currency || root.dataset.currency || 'JPY' }).format(value / 100);
  const quantity = input => {
    const value = Number(input.value);
    return Number.isSafeInteger(value) && value >= 1 ? value : null;
  };
  const limits = option => ({ min: Math.max(1, Number(option?.dataset.min) || 1), step: Math.max(1, Number(option?.dataset.step) || 1), max: Math.min(999, Number(option?.dataset.max) || 999) });
  const optionOf = card => card.querySelector('[data-catalog-variant]')?.selectedOptions[0];
  function priceBreaks(option) {
    if (!approved) return [];
    try {
      const rows = JSON.parse(option?.dataset.priceBreaks || '[]');
      if (!Array.isArray(rows)) return [];
      return rows.filter(tier => Number.isSafeInteger(tier.min) && tier.min > 0 && Number.isSafeInteger(tier.price) && tier.price > 0).sort((a, b) => a.min - b.min);
    } catch { return []; }
  }
  function unitPrice(basePrice, tiers, amount) {
    return tiers.reduce((price, tier) => amount >= tier.min ? tier.price : price, basePrice);
  }
  function estimateAddition(basePrice, tiers, existing, added) {
    const totalQuantity = existing + added;
    const unit = unitPrice(basePrice, tiers, totalQuantity);
    const total = unit * totalQuantity;
    return { unit, total, delta: total - unitPrice(basePrice, tiers, existing) * existing, totalQuantity };
  }
  const cartQuantity = option => (cart?.items || []).filter(item => Number(item.variant_id) === Number(option?.value) && !item.selling_plan_allocation).reduce((sum, item) => sum + item.quantity, 0);
  function updateCard(card) {
    const option = optionOf(card);
    if (!option) return;
    const input = card.querySelector('[data-catalog-quantity]');
    const q = quantity(input);
    const rule = limits(option);
    input.min = rule.min; input.step = rule.step; input.max = rule.max;
    const existing = cartQuantity(option);
    const valid = q !== null && q >= rule.min && existing + q <= rule.max && (q - rule.min) % rule.step === 0;
    const tiers = priceBreaks(option);
    const estimate = estimateAddition(Number(option.dataset.price), tiers, existing, q || 0);
    card.querySelector('[data-catalog-price]').textContent = `${money(estimate.unit)} / 1kg${approved ? '（追加後の単価目安）' : ''}`;
    card.querySelector('[data-catalog-line-total]').textContent = valid ? (approved ? `追加後 ${estimate.totalQuantity}kg・対象商品計 ${money(estimate.total)}（目安）／今回の差額 ${money(estimate.delta)}` : `${q}kg 合計 ${money(Number(option.dataset.price) * q)}`) : (existing >= rule.max ? 'カートの数量が上限に達しています。' : '数量をご確認ください');
    card.querySelector('[data-catalog-add]').disabled = busy || !cart || option.disabled || !valid;
    card.querySelector('[data-qty-minus]').disabled = busy || (q !== null && q <= rule.min);
    card.querySelector('[data-qty-plus]').disabled = busy || (q !== null && existing + q >= rule.max);
  }
  function lock(value) {
    busy = value;
    root.setAttribute('aria-busy', String(value));
    root.querySelectorAll('button:not([data-catalog-filter]),select,input:not([data-catalog-search])').forEach(el => { el.disabled = value; });
    cards.forEach(updateCard);
  }
  async function api(path, body) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(base + path, { method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' }, body: body ? JSON.stringify(body) : undefined, signal: controller.signal });
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : '更新できませんでした。カートを確認してください。');
      return data;
    } catch (error) {
      if (controller.signal.aborted) throw new Error('通信がタイムアウトしました。カートを確認してください。');
      throw error;
    } finally {
      clearTimeout(timer);
    }
  }
  function renderCart(data) {
    cart = data;
    const list = root.querySelector('[data-cart-items]');
    list.replaceChildren();
    root.querySelector('[data-cart-count]').textContent = `${data.item_count}点`;
    root.querySelector('[data-cart-total]').textContent = money(data.items_subtotal_price ?? data.total_price);
    root.querySelector('[data-mobile-cart-count]').textContent = `${data.item_count}点`;
    root.querySelector('[data-mobile-cart-total]').textContent = money(data.items_subtotal_price ?? data.total_price);
    data.items.forEach(item => {
      const row = document.createElement('article'); row.className = 'fcatalog-cart-item';
      const title = document.createElement('p'); title.textContent = item.product_title || item.title;
      const detail = document.createElement('p'); detail.className = 'fcatalog-help'; detail.textContent = `${item.variant_title || ''} × ${item.quantity}`;
      const price = document.createElement('p'); price.textContent = money(item.final_line_price);
      row.append(title, detail, price);
      if (item.selling_plan_allocation) {
        const plan = document.createElement('small'); plan.textContent = `定期購入：${item.selling_plan_allocation.selling_plan?.name || '契約プラン'}（この画面では変更できません）`; row.append(plan);
      } else if (knownIds.has(Number(item.variant_id))) {
        const itemOption = [...root.querySelectorAll('[data-catalog-variant] option')].find(option => Number(option.value) === Number(item.variant_id));
        const itemRule = limits(itemOption);
        const controls = document.createElement('div'); controls.className = 'fcatalog-cart-stepper';
        const minus = document.createElement('button'); minus.type = 'button'; minus.textContent = '−'; minus.setAttribute('aria-label', `${item.product_title}の数量を減らす`);
        const count = document.createElement('span'); count.textContent = `${item.quantity}袋`;
        const plus = document.createElement('button'); plus.type = 'button'; plus.textContent = '＋'; plus.setAttribute('aria-label', `${item.product_title}の数量を増やす`);
        minus.addEventListener('click', () => changeLine(item.key, item.quantity <= itemRule.min ? 0 : Math.max(itemRule.min, item.quantity - itemRule.step), item.quantity));
        plus.addEventListener('click', () => changeLine(item.key, item.quantity + itemRule.step, item.quantity));
        controls.append(minus, count, plus); row.append(controls);
        const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'fcatalog-remove'; remove.textContent = 'この商品をカートから外す';
        remove.addEventListener('click', () => changeLine(item.key, 0, item.quantity)); row.append(remove);
      } else {
        const note = document.createElement('small'); note.textContent = '変更はカートページで行えます。'; row.append(note);
      }
      list.append(row);
    });
    status.textContent = data.item_count ? '現在のカート内容です。' : 'カートに商品は入っていません。';
    cards.forEach(updateCard);
  }
  async function refresh() {
    if (busy) return;
    lock(true);
    try { renderCart(await api('cart.js')); }
    catch (error) { cart = null; status.textContent = 'カートを読み込めませんでした。「最新の内容に更新」をお試しください。'; }
    finally { lock(false); }
  }
  async function changeLine(key, amount, expectedQuantity) {
    if (busy) return;
    lock(true);
    try {
      const fresh = await api('cart.js');
      const item = fresh.items.find(line => line.key === key);
      if (!item || item.selling_plan_allocation || !knownIds.has(Number(item.variant_id))) { renderCart(fresh); throw new Error('カート内容が変わりました。現在の内容をご確認ください。'); }
      if (item.quantity !== expectedQuantity) { renderCart(fresh); throw new Error('別の画面で数量が更新されました。最新の数量をご確認のうえ、もう一度操作してください。'); }
      const option = [...root.querySelectorAll('[data-catalog-variant] option')].find(o => Number(o.value) === Number(item.variant_id));
      const rule = limits(option);
      const otherQuantity = fresh.items.filter(line => line.key !== key && Number(line.variant_id) === Number(item.variant_id) && !line.selling_plan_allocation).reduce((sum, line) => sum + line.quantity, 0);
      if (!Number.isSafeInteger(amount) || amount < 0 || (amount > 0 && (amount < rule.min || (amount - rule.min) % rule.step !== 0)) || (amount > item.quantity && amount + otherQuantity > rule.max)) {
        renderCart(fresh); throw new Error('注文可能な数量をご確認ください。');
      }
      renderCart(await api('cart/change.js', { id: key, quantity: amount }));
    } catch (error) { status.textContent = error.message; }
    finally { lock(false); }
  }
  cards.forEach(card => {
    const select = card.querySelector('[data-catalog-variant]');
    if (!select) return;
    const input = card.querySelector('[data-catalog-quantity]');
    const feedback = card.querySelector('[data-card-feedback]');
    const firstAvailable = [...select.options].find(o => !o.disabled);
    if (firstAvailable) select.value = firstAvailable.value;
    input.value = limits(optionOf(card)).min;
    select.addEventListener('change', () => { input.value = limits(optionOf(card)).min; feedback.textContent = ''; updateCard(card); });
    input.addEventListener('input', () => { feedback.textContent = ''; updateCard(card); });
    card.querySelector('[data-qty-minus]').addEventListener('click', () => { const r = limits(optionOf(card)); input.value = Math.max(r.min, (quantity(input) || r.min) - r.step); updateCard(card); });
    card.querySelector('[data-qty-plus]').addEventListener('click', () => { const r = limits(optionOf(card)); input.value = Math.min(r.max, (quantity(input) || r.min) + r.step); updateCard(card); });
    card.querySelector('[data-catalog-add]').addEventListener('click', async () => {
      if (busy) return;
      const selected = optionOf(card), q = quantity(input), rule = limits(selected);
      if (!selected || selected.disabled || q === null || q < rule.min || q > rule.max || (q - rule.min) % rule.step !== 0) { feedback.textContent = '購入可能な数量を整数で選択してください。'; return; }
      lock(true); feedback.textContent = 'カートに追加しています。';
      try {
        const fresh = await api('cart.js');
        const inCart = fresh.items.filter(item => Number(item.variant_id) === Number(selected.value) && !item.selling_plan_allocation).reduce((sum, item) => sum + item.quantity, 0);
        if (inCart + q > rule.max) throw new Error('注文可能な数量を超えています。');
        await api('cart/add.js', { items: [{ id: Number(selected.value), quantity: q }] });
        input.value = rule.min;
        renderCart(await api('cart.js')); feedback.textContent = `${q}袋をカートに追加しました。`;
      } catch (error) { feedback.textContent = error.message + ' 再度追加する前にカートをご確認ください。'; }
      finally { lock(false); }
    });
  });
  root.querySelector('[data-cart-refresh]').addEventListener('click', refresh);
  let filter = 'all';
  const search = root.querySelector('[data-catalog-search]');
  function filterCards() {
    const query = search.value.trim().normalize('NFKC').toLocaleLowerCase('ja-JP');
    let count = 0;
    cards.forEach(card => {
      const match = (filter === 'all' || card.dataset.category === filter) && (card.dataset.search || '').normalize('NFKC').toLocaleLowerCase('ja-JP').includes(query);
      card.hidden = !match; if (match) count++;
    });
    root.querySelector('[data-catalog-results]').textContent = count ? `${count}件の商品` : '該当する商品がありません。検索条件を変更してください。';
  }
  search.addEventListener('input', filterCards);
  root.querySelectorAll('[data-catalog-filter]').forEach(button => button.addEventListener('click', () => {
    filter = button.dataset.catalogFilter;
    root.querySelectorAll('[data-catalog-filter]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
    filterCards();
  }));
  const panel = root.querySelector('[data-cart-panel]');
  const mobile = window.matchMedia('(max-width: 800px)');
  panel.open = !mobile.matches;
  root.querySelector('.fcatalog-mobile-cart').addEventListener('click', () => { panel.open = true; });
  filterCards();
  window.addEventListener('pageshow', event => {
    if (event.persisted) refresh();
  });
  refresh();
})();
